import { render, staticRenderFns } from "./ConversationParticipant.vue?vue&type=template&id=64d79e63&scoped=true&"
import script from "./ConversationParticipant.vue?vue&type=script&lang=js&"
export * from "./ConversationParticipant.vue?vue&type=script&lang=js&"
import style0 from "./ConversationParticipant.vue?vue&type=style&index=0&id=64d79e63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d79e63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d79e63')) {
      api.createRecord('64d79e63', component.options)
    } else {
      api.reload('64d79e63', component.options)
    }
    module.hot.accept("./ConversationParticipant.vue?vue&type=template&id=64d79e63&scoped=true&", function () {
      api.rerender('64d79e63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/ConversationParticipant.vue"
export default component.exports